import cn from 'classnames'
import * as React from 'react'
import { Link } from 'react-router-dom'

import styles from './nav-link.module.scss'

interface INavLinkProps {
  href: string
  className?: string
  children: React.ReactNode
  isExternal?: boolean
  variant?: 'desktop' | 'mobile'
  main?: boolean
}

export default function NavLink({
  href,
  className,
  children,
  isExternal,
  variant = 'desktop',
  main = false,
  ...rest
}: INavLinkProps & React.HTMLAttributes<HTMLAnchorElement>) {
  const fullClassName = cn(
    styles.root,
    window.location.pathname === href && styles.active,
    styles.free,
    styles[variant],
    main && styles.mainLink,
    className
  )

  if (isExternal) {
    return (
      <a className={fullClassName} href={href} {...rest}>
        {children}
      </a>
    )
  }
  return (
    <Link {...rest} className={fullClassName} to={href}>
      {children}
    </Link>
  )
}
